export const CONFIG = {
  API_BASE_URL: import.meta.env.VITE_BASE_API_URL,
  WIDGET_CONTAINER_ID: "tfg-widget",
  WIDGET_WRAPPER_CLASS: "tfg-widget-wrapper",
  MODAL_CLASS: "tfg-modal",
  CTA_CLASS: "tfg-cta",
  PB_CLASS: "tfg-pb",
  PB_LOGO_CLASS: "tfg-logo",
}
